/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.8"
        height="18.92"
        viewBox="0 0 13.8 18.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M13.8 5.17 8.58 0H0v18.92h13.8ZM8.87 1.7l3.21 3.18H8.87Zm3.93 16.22H1V1h6.87v4.88h4.93ZM7.53 7.75h-1v.81a2.19 2.19 0 0 0-1.33.59 1.54 1.54 0 0 0-.43 1.17c0 1 .9 1.41 1.76 1.64v1.82a2.35 2.35 0 0 1-1.3-.66l-.11-.1-.7.72.1.09a3.41 3.41 0 0 0 2 .95v.79h1v-.78a2.35 2.35 0 0 0 1.39-.63 1.63 1.63 0 0 0 .45-1.2c0-1.25-1.16-1.6-1.84-1.77V9.61a2.14 2.14 0 0 1 1 .48l.1.11.74-.67-.1-.11a3 3 0 0 0-1.76-.85Zm-1 3.17c-.68-.23-.75-.45-.76-.65a.56.56 0 0 1 .15-.43 1.06 1.06 0 0 1 .6-.27ZM8.36 13a.57.57 0 0 1-.17.47 1.16 1.16 0 0 1-.66.31v-1.55c.66.27.82.42.83.77Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PaperFoldedCornerWithDollarSignIcon';

export default Icon;
